// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".greyBlock[data-v-253a6710]{background:#d3d3d3;min-height:200px;padding:20px;padding-bottom:50px;overflow:hidden;overflow-y:scroll}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
